import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider, useAuth } from "react-oidc-context";
import { localStorageUserStore } from "./auth/oidc-localstorage";

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_BO5zyrSKA",
  client_id: "76u29f2ll32p5p6jm4ovf85oro",
  redirect_uri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
  response_type: "code",
  scope: "email openid phone", // added offline_access
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTime: 60,
};

function AppWithUrlCleanup() {
  const auth = useAuth();
  const triedSilentSignin = useRef(false);

  useEffect(() => {
    if (auth.isAuthenticated) {
      // Remove code and state from URL after login
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [auth.isAuthenticated]);

  useEffect(() => {
    // On a fresh page load the stored access token is often already expired
    // (browser was closed past its ~1hr lifetime), which alone reports as
    // signed out. Use the still-valid refresh token to restore the session
    // silently instead of forcing the user back through the login screen.
    //
    // Only do this when a stored (if expired) user is actually present:
    // without one, oidc-client-ts has no refresh token to use and falls
    // back to a hidden-iframe signin against Cognito, which fails with
    // "login_required" for anyone without an active hosted-UI session
    // (e.g. right after logging out, or a first-time visitor) and would
    // otherwise leave auth.error permanently set, wedging the app on an
    // error screen instead of showing the normal sign-in button.
    if (
      auth.user &&
      !auth.isAuthenticated &&
      !auth.isLoading &&
      !auth.activeNavigator &&
      !triedSilentSignin.current
    ) {
      triedSilentSignin.current = true;
      auth.signinSilent().catch(() => {
        // Refresh token also expired/invalid - fall through to the
        // normal sign-in screen.
      });
    }
  }, [auth]);

  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig} userStore={localStorageUserStore()}>
      <AppWithUrlCleanup />
    </AuthProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
